import { QrCamera } from "../../../qr/qrCamera/QrCamera";
import React, { useState } from "react";
import { QrTypes } from "../../../qr/enums";
import { useCameraScanner } from "../../../printSettings/freya/useCameraScanner";
import {
  StaffOverrideStatusContent
} from "../../dialog/staffOverrideCameraDialog/statusContent/StaffOverrideStatusContent";
import { ScannerInput } from "../../../freya/scanBadge/scannerInput/ScannerInput";
import QrScanner from "qr-scanner";
import { STAFF_OVERRIDE_CAMERA_KEY } from "../../../../common/constants";

type Props = {
  scanStatus: QrTypes;
  onScan: (result: QrScanner.ScanResult, skipValidation?: boolean) => Promise<void>;
  scannerMode?: boolean;
  scannerProps?: {
    onScannerInputChange: (evt: React.ChangeEvent<HTMLInputElement>) => void;
  }
}

export const CameraModeContent = ({ scanStatus, onScan, scannerProps, scannerMode }: Props) => {
  const [videoRef, setVideoRef] = useState<HTMLVideoElement>();
  useCameraScanner({ videoRef, onScan, useIndexDB: true, deviceStorageKey: STAFF_OVERRIDE_CAMERA_KEY });

  if (scannerMode && scannerProps) {
    return <>
      <StaffOverrideStatusContent status={scanStatus} />
      <ScannerInput key={String(scanStatus)} onScannerInputChange={scannerProps.onScannerInputChange} />
    </>
  }

  return <QrCamera setRef={setVideoRef} type={scanStatus} shouldUpdateStyles />;
}